/* Adikopas: vardo ir numerio peržiūros prekės puslapyje.
   Peržiūros elementus (.adk-plate__name ir .adk-plate__num) sukuria ir atnaujina
   colour-filter.js; šis failas jo neliečia — tik išskiria juos į DU atskirus blokus:
   vardo peržiūra dedama virš vardo laukelio, numerio — virš numerio laukelio. */
(function () {
  var CSS = [
    '.adk-p2{position:relative;overflow:hidden;text-align:center;margin:18px 0 14px;padding:20px 18px 22px;',
    'background:#17181a;border-radius:10px;',
    'box-shadow:inset 0 0 0 1px rgba(255,255,255,.09),0 10px 28px rgba(0,0,0,.16)}',
    '.adk-p2::before{content:"";position:absolute;inset:9px;border:1px dashed rgba(255,255,255,.10);',
    'border-radius:6px;pointer-events:none}',
    '.adk-p2__cap{position:relative;z-index:1;font-size:.7rem;letter-spacing:.12em;',
    'text-transform:uppercase;color:rgba(255,255,255,.45);margin:0 0 10px}',
    '.adk-p2 .adk-plate__name{position:relative;z-index:1;display:block;margin:0;',
    'font-size:clamp(28px,7vw,46px);line-height:1.06;letter-spacing:.07em}',
    '.adk-p2 .adk-plate__num{position:relative;z-index:1;display:block;margin:0;',
    'font-size:clamp(92px,26vw,150px);line-height:.94;letter-spacing:-.01em}',
    '.adk-p2 .adk-plate__empty{opacity:.3}',
    '.adk-plate{display:none!important}',
    '@keyframes adkName{from{opacity:0;transform:translateX(-38px) skewX(-8deg)}',
    '55%{opacity:1;transform:translateX(4px) skewX(0)}to{opacity:1;transform:none}}',
    '@keyframes adkNum{from{opacity:0;transform:scale(.45)}',
    '55%{opacity:1;transform:scale(1.14)}75%{transform:scale(.96)}to{opacity:1;transform:scale(1)}}',
    '.adk-p2 .adk-anim--name{animation:adkName .55s cubic-bezier(.2,.8,.3,1)}',
    '.adk-p2 .adk-anim--num{animation:adkNum .6s cubic-bezier(.2,.8,.3,1)}',
    '@media (prefers-reduced-motion:reduce){.adk-p2 .adk-anim--name,',
    '.adk-p2 .adk-anim--num{animation:none}}',
    '@media (max-width:749px){.adk-p2{padding:16px 14px 18px}}'
  ].join('');

  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var CAP_NAME = EN ? 'This is how the name will look' : 'Taip atrodys užrašas';
  var CAP_NUM = EN ? 'This is how the number will look' : 'Taip atrodys numeris';

  function addCss() {
    if (document.getElementById('adk-plate-css')) return;
    var s = document.createElement('style');
    s.id = 'adk-plate-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* Laukelis pagal jo užrašą: vardo arba numerio. */
  function field(words) {
    var fields = document.querySelectorAll('product-custom-property-component');
    for (var i = 0; i < fields.length; i++) {
      var t = (fields[i].textContent || '').toLowerCase();
      for (var j = 0; j < words.length; j++) {
        if (t.indexOf(words[j]) > -1) return fields[i];
      }
    }
    return null;
  }

  function box(cap, node, id) {
    var b = document.createElement('div');
    b.className = 'adk-p2';
    b.id = id;
    var c = document.createElement('div');
    c.className = 'adk-p2__cap';
    c.textContent = cap;
    b.appendChild(c);
    b.appendChild(node);
    return b;
  }

  function pop(el, cls) {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  /* Animacija paleidžiama nustojus rašyti — kitaip kiekvienas simbolis ją
     nutrauktų iš naujo ir judesio nesimatytų. */
  function watch(el, cls) {
    if (!el || el.dataset.adkWatched) return;
    el.dataset.adkWatched = '1';
    var last = el.textContent;
    var timer = null;
    new MutationObserver(function () {
      if (el.textContent === last) return;
      last = el.textContent;
      clearTimeout(timer);
      timer = setTimeout(function () {
        pop(el, cls);
      }, 300);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function split() {
    var plate = document.querySelector('.adk-plate');
    if (!plate) return false;
    var nameNode = document.querySelector('.adk-plate__name');
    var numNode = document.querySelector('.adk-plate__num');
    if (!nameNode || !numNode) return false;

    var nameField = field(['vardas', 'name']);
    var numField = field(['numeris', 'number']);
    if (!nameField || !numField) return true;

    if (!document.getElementById('adk-p2-name')) {
      nameField.parentNode.insertBefore(box(CAP_NAME, nameNode, 'adk-p2-name'), nameField);
    }
    if (!document.getElementById('adk-p2-num')) {
      numField.parentNode.insertBefore(box(CAP_NUM, numNode, 'adk-p2-num'), numField);
    }
    watch(nameNode, 'adk-anim--name');
    watch(numNode, 'adk-anim--num');
    return true;
  }

  function run() {
    addCss();
    if (split()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (split() || tries > 40) clearInterval(t);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
